<ngb-carousel role="listbox">
  @for (url of imageArr; let i = $index; track url; ) {
    <ng-template ngbSlide class="carousel slide" data-ride="carousel">
      <a [routerLink]="'fulldetails/' + addressHyphenStr + '/' + cityHyphenStr + '/' + MLSNum"><img fill class="d-block img-fluid img-responsive vh-50 w-100" style="height: 50vh;" src="{{url}}" (error)="replaceImage({_elementObj: this, _indexNum: i})" alt="{{MLSNum}}"/></a>
    </ng-template>
  }
</ngb-carousel>
